export default {
  apiKey: "AIzaSyATPadSASIzee7r2e6IH_OIPYtRBro-36g",
  authDomain: "irem-blog.firebaseapp.com",
  projectId: "irem-blog",
  storageBucket: "irem-blog.appspot.com",
  messagingSenderId: "549253026682",
  appId: "1:549253026682:web:237de5ddd8c2998509fcc3",
  measurementId: "G-Q9RV8KW6ZE"
};
